import * as React from 'react'
import { FileSelector } from './FileSelector'
import {
  addStandards,
  StandardsIngestion,
  updateStandards,
} from 'components/tree/standardUtilities'
import { ToggleButton, ToggleButtonGroup } from '@mui/material'
import { Standard } from 'shared/types'
import { Table } from 'shared/ui/Table/Table'

export function IngestStandards() {
  const [ingestionProgress, setIngestionProgress] = React.useState<number>(0)

  const [updatedStandards, setUpdatedStandards] = React.useState<Standard[]>()
  const [addedStandards, setAddedStandards] = React.useState<Standard[]>()

  const [addOrUpdate, setAddOrUpdate] = React.useState<string>('add')

  const [addingAllProgress, setAddingAllProgress] = React.useState(0)

  const updateColumns = React.useMemo(() => {
    return [
      {
        title: 'ID',
        width: 100,
        rowContent(standard: any) {
          return <>{standard.standardId}</>
        },
      },
      {
        title: 'Name',
        width: 100,
        rowContent(standard: any) {
          return <>{standard.standardName}</>
        },
      },
      {
        title: 'Previous Description',
        width: 350,
        rowContent(standard: any) {
          return <>{standard.previousDescription}</>
        },
      },
      {
        title: 'New Description',
        width: 350,
        rowContent(standard: any) {
          return <>{standard.standardDescription}</>
        },
      },
    ]
  }, [])

  const addColumns = React.useMemo(() => {
    return [
      {
        title: 'State',
        width: 100,
        rowContent(a: Standard) {
          return <>{a.state}</>
        },
      },
      {
        title: 'Grade',
        width: 100,
        rowContent(a: Standard) {
          return <>{a.gradeId}</>
        },
      },
      {
        title: 'Subject',
        width: 100,
        rowContent(a: Standard) {
          return <>{a.subjectId}</>
        },
      },
      {
        title: 'Name',
        width: 200,
        rowContent(a: Standard) {
          return <>{a.standardName}</>
        },
      },
      {
        title: 'Description',
        width: 1000,
        rowContent(a: Standard) {
          return <>{a.standardDescription}</>
        },
      },
    ]
  }, [])

  return (
    <>
      EdGate File
      <FileSelector
        filesSelected={(file, asWebKit) => {
          const standardsIngestion = new StandardsIngestion(
            file[0],
            setIngestionProgress,
          )
          standardsIngestion
            .getUpdatedAndNewStandards()
            .then(([updatedStandards, newStandards]) => {
              setUpdatedStandards(updatedStandards)
              setAddedStandards(newStandards)
            })
        }}
      />
      Parsing Progress
      <progress value={ingestionProgress} />
      <ToggleButtonGroup
        value={addOrUpdate}
        exclusive
        onChange={(e, v) => setAddOrUpdate(v)}
      >
        <ToggleButton value="add">Standards to Add</ToggleButton>
        <ToggleButton value="update">Standards To Update</ToggleButton>
      </ToggleButtonGroup>
      {addedStandards && addOrUpdate === 'add' && (
        <div>
          <button
            onClick={() => {
              for (let cp = 0; cp * 1000 < addedStandards.length; cp += 1) {
                addStandards(
                  addedStandards.slice(cp * 1000, cp * 1000 + 1000),
                ).then(() => {
                  setAddingAllProgress((x) => x + 1000 / addedStandards.length)
                })
              }
            }}
          >
            Add All
          </button>
          Progress of Adding All:
          <progress value={addingAllProgress}></progress>
          <Table<Standard> columns={addColumns} items={addedStandards} />
        </div>
      )}
      {updatedStandards && addOrUpdate === 'update' && (
        <div>
          <button
            onClick={() => {
              for (let cp = 0; cp * 1000 < updatedStandards.length; cp += 1) {
                updateStandards(
                  updatedStandards.slice(cp * 1000, cp * 1000 + 1000),
                ).then(() => {
                  setAddingAllProgress(
                    (x) => x + 1000 / updatedStandards.length,
                  )
                })
              }
            }}
          >
            Update All
          </button>
          <Table<Standard> columns={updateColumns} items={updatedStandards} />
        </div>
      )}
    </>
  )
}
